import { Component } from '@angular/core';
import { PriceComponent } from 'gung-standard';

@Component({
    selector: 'car-liner-price',
    templateUrl: './car-liner-price.component.html',
    styleUrls: ['./car-liner-price.component.scss'],
    standalone: false
})
export class CarLinerPriceComponent extends PriceComponent { }